<script lang="ts">
  import { api } from '../../lib/api/client';
  import PeriodPicker from './PeriodPicker.svelte';
  import type { CitySummary, CountrySummary } from '../../lib/api/types';
  import { t } from '../../lib/i18n/index.ts';
  import { countryName, shortDate, span, timelineBase } from './format';

  // Cities lists the countries and cities visited, with the places in each
  // and the last visit (005 FR-039).
  let { groupId, userId, self }: { groupId?: string; userId: string; self: boolean } = $props();

  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let sort = $state('visits');
  // period is the from and to of the chosen stretch, empty for all time.
  let period = $state('');
  let cities = $state<CitySummary[] | null>(null);
  let countries = $state<CountrySummary[] | null>(null);
  let error = $state('');

  $effect(() => {
    load(sort, period);
  });

  async function load(s: string, range: string) {
    error = '';
    const base = timelineBase(groupId, userId, self);
    const q = `tz=${encodeURIComponent(tz)}&sort=${s}${range}`;
    try {
      [cities, countries] = await Promise.all([
        api.get<CitySummary[]>(`${base}/cities?${q}`),
        api.get<CountrySummary[]>(`${base}/countries?${q}`),
      ]);
    } catch (e: any) {
      error = e.message;
      cities = countries = null;
    }
  }
</script>

<div class="flex-1 overflow-y-auto p-6">
  <div class="max-w-3xl mx-auto space-y-4">
    <div class="flex items-center gap-3 flex-wrap">
      <PeriodPicker bind:query={period} />
      <select class="input w-48" bind:value={sort} aria-label={t('timelineSort')}>
      <option value="visits">{t('timelineSortVisits')}</option>
      <option value="time">{t('timelineSortTime')}</option>
      <option value="recent">{t('timelineSortRecent')}</option>
      </select>
    </div>

    {#if error}
      <p class="text-sm" style="color: var(--theme-error);">{error}</p>
    {:else if countries && cities}
      <section class="card p-5">
        <h2 class="font-semibold mb-2">{t('timelineCountryCount', { n: countries.length })}</h2>
        {#each countries as c (c.country_code)}
          <div class="py-2 flex items-baseline gap-3">
            <span class="flex-1 font-medium">{countryName(c.country_code, c.country)}</span>
            <span class="text-sm text-text-muted text-right">
              {t('timelineCountryStats', { cities: c.cities, places: c.places, time: span(c.seconds) })}<br />{t('timelineLastVisit', { date: shortDate(c.last_visit) })}
            </span>
          </div>
        {/each}
      </section>
      <section class="card p-5">
        <h2 class="font-semibold mb-2">{t('timelineCityCount', { n: cities.length })}</h2>
        {#each cities as c (`${c.country_code}/${c.city}`)}
          <div class="py-2 flex items-baseline gap-3">
            <span class="flex-1 min-w-0">
              <span class="block font-medium truncate">{c.city}</span>
              <span class="block text-xs text-text-muted">{countryName(c.country_code, c.country)}</span>
            </span>
            <span class="text-sm text-text-muted text-right">
              {t('timelinePlacesTime', { places: c.places, time: span(c.seconds) })}<br />{t('timelineLastVisit', { date: shortDate(c.last_visit) })}
            </span>
          </div>
        {/each}
      </section>
    {/if}
  </div>
</div>
